import React, { useEffect, useState } from 'react';
import './Contact.css';

const NewContact = () => {
  const [scrollY, setScrollY] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      // Send email directly to backend
      const response = await fetch('http://localhost:3001/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok) {
        setSubmitStatus('success');
        // Reset form after success
        setTimeout(() => {
          setFormData({
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: ''
          });
          setSubmitStatus('');
        }, 3000);
      } else {
        throw new Error(result.error || 'Failed to send email');
      }
      
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="new-contact">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <a href="/" className="logo-link">
              <span className="logo-text">I-Revive</span>
            </a>
          </div>
          <div className="nav-menu">
            <a href="/" className="nav-link">Home</a>
            <a href="/about" className="nav-link">About</a>
            <a href="/contact" className="nav-link active">Contact</a>
          </div>
          <div className="nav-cta">
            <a href="#preorder" className="btn btn-primary">Pre-Order</a>
          </div>
        </div>
      </nav>

      {/* Contact Main Section */}
      <section className="contact-main">
        <div className="container">
          {/* Centered Get in Touch Header */}
          <div className="contact-header">
            <h1 className="contact-main-title">
              Get in <span className="highlight">Touch</span>
            </h1>
            <p className="contact-main-subtitle">
              Ready to revolutionize your foot health? We're here to answer your questions and help you get started with I-Revive.
            </p>
          </div>

          <div className="contact-content">
            {/* Contact Form */}
            <div className="contact-form-section">
              <div className="form-header">
                <h2>Send Us a Message</h2>
                <p>Have questions about I-Revive? We'd love to hear from you. Fill out the form below and we'll get back to you as soon as possible.</p>
              </div>
              
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter your email address"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Enter your phone number"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select a subject</option>
                      <option value="Pre-Order Inquiry">Pre-Order Inquiry</option>
                      <option value="Technical Questions">Technical Questions</option>
                      <option value="Partnership Opportunity">Partnership Opportunity</option>
                      <option value="Customer Support">Customer Support</option>
                      <option value="Media & Press">Media & Press</option>
                      <option value="General Inquiry">General Inquiry</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="6"
                    placeholder="Tell us how we can help you..."
                  ></textarea>
                </div>
                
                <button 
                  type="submit" 
                  className={`btn btn-primary form-submit ${isSubmitting ? 'submitting' : ''}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                  <span className="btn-arrow">→</span>
                </button>

                {submitStatus === 'success' && (
                  <div className="form-status success">
                    <span className="status-icon">✓</span>
                    Thank you! Your message has been sent successfully. We'll get back to you soon.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="form-status error">
                    <span className="status-icon">!</span>
                    Sorry, there was an error sending your message. Please try again or contact us directly at vivek@craftmystrength.com
                  </div>
                )}
              </form>
            </div>
            
            {/* Visit Our Office Info */}
            <div className="visit-office-section">
              <div className="visit-office-card">
                <h3>Visit Our Office</h3>
                <div className="office-info">
                  <div className="info-item">
                    <div className="info-icon email-icon">
                      <span>✉</span>
                    </div>
                    <div className="info-content">
                      <h4>Email</h4>
                      <p>vivek@craftmystrength.com</p>
                    </div>
                  </div>
                  
                  <div className="info-item">
                    <div className="info-icon website-icon">
                      <span>🌐</span>
                    </div>
                    <div className="info-content">
                      <h4>Website</h4>
                      <p>www.CraftMyStrength.com</p>
                    </div>
                  </div>
                  
                  <div className="info-item">
                    <div className="info-icon location-icon">
                      <span>📍</span>
                    </div>
                    <div className="info-content">
                      <h4>Office Locations</h4>
                      <p>Hong Kong & India<br/>Multiple office locations</p>
                    </div>
                  </div>
                </div>
                
                <div className="contact-hours">
                  <h4>Business Hours</h4>
                  <div className="hours-list">
                    <div className="hours-item">
                      <span>Monday - Friday</span>
                      <span>9:00 AM - 6:00 PM</span>
                    </div>
                    <div className="hours-item">
                      <span>Saturday</span>
                      <span>10:00 AM - 4:00 PM</span>
                    </div>
                    <div className="hours-item">
                      <span>Sunday</span>
                      <span>Closed</span>
                    </div>
                  </div>
                  <p className="hours-note">All times are in local time zones</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Location & Map Section */}
      <section className="location-section">
        <div className="container">
          <div className="location-content">
            <div className="map-container">
              <div className="map-wrapper">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.568537085448!2d114.15465931495482!3d22.280787785328!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3404007a2493589f%3A0x8b1f7b4b7f8b9b9b!2sHong%20Kong!5e0!3m2!1sen!2s!4v1643234567890!5m2!1sen!2s"
                  width="100%"
                  height="400"
                  style={{border: 0}}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="CraftMyStrength Hong Kong Office Location"
                ></iframe>
                <div className="map-overlay">
                  <div className="map-marker">
                    <span className="marker-icon">📍</span>
                    <div className="marker-info">
                      <h4>CraftMyStrength</h4>
                      <p>Hong Kong & India</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <div className="section-header">
            <h2>Frequently Asked Questions</h2>
            <p>Find quick answers to common questions about I-Revive</p>
          </div>
          
          <div className="faq-grid">
            <div className="faq-item">
              <h4>What is I-Revive?</h4>
              <p>I-Revive is the world's first smart recovery footwear with built-in EMS and TENS technologies that actively enhance foot health and recovery.</p>
            </div>
            
            <div className="faq-item">
              <h4>Is I-Revive FDA approved?</h4>
              <p>Yes, I-Revive has received FDA clearance (510K) and is recognized as a medical device under IEC 60601 standards.</p>
            </div>
            
            <div className="faq-item">
              <h4>How does the technology work?</h4>
              <p>I-Revive uses EMS to stimulate muscles and TENS for pain relief and circulation to provide personalized therapy for your feet.</p>
            </div>
            
            <div className="faq-item">
              <h4>Who can use I-Revive?</h4>
              <p>I-Revive is perfect for desk workers, athletes, travelers, elderly individuals, and anyone looking to improve their foot health and recovery.</p>
            </div>
            
            <div className="faq-item">
              <h4>When will I-Revive be available?</h4>
              <p>I-Revive is currently available for pre-order and will begin shipping to customers in 2025.</p>
            </div>
            
            <div className="faq-item">
              <h4>What's included in the package?</h4>
              <p>Each I-Revive package includes the smart slippers, detachable sole system, charging accessories, and access to the companion mobile app.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Simplified Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3>I-Revive</h3>
              <p className="tagline">Enhance Mobility, Accelerate Recovery</p>
              <p className="description">Revolutionary footwear technology that enhances mobility, accelerates recovery, and transforms foot health through advanced EMS and TENS integration.</p>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <span className="icon">✉</span>
                  <span>vivek@craftmystrength.com</span>
                </div>
                <div className="footer-contact-item">
                  <span className="icon">🌐</span>
                  <span>www.CraftMyStrength.com</span>
                </div>
                <div className="footer-contact-item">
                  <span className="icon">📍</span>
                  <span>Hong Kong & India</span>
                </div>
              </div>
            </div>
            
            <div className="footer-col">
              <h4>Product</h4>
              <a href="/about">About</a>
              <a href="/home">Product</a>
              <a href="/about">About Us</a>
            </div>
            
            <div className="footer-col">
              <h4>Support</h4>
              <a href="/contact">Contact Us</a>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; <span className="year">2025</span> CraftMyStrength. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NewContact;